import React, { useState } from 'react';
import { string, object } from 'prop-types';
import { Avatar } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import ClientLogo from '../ClientLogo';
import { descriptionHasMore, getClientLogoPath } from '../helper';
import DateDisplay from './dateDisplay';
import './style.scss';

const DetailsPopover = ({ profilePhoto, sellerName, client }) => {
    const [ moreInfoOpen, setMoreInfoOpen ] = useState(false);
    const { started_at, ended_at, interaction_description, enriched_details } = client;
    const { name, description, industry } = enriched_details;
    const logoPath = getClientLogoPath(client);
    const [ hasMoreInfo, previewDescription ] = descriptionHasMore(description);
    const showEnrichBox = !!(description || industry);
    const hasMoreKey = `gig_page_perseus.notableClients.${moreInfoOpen ? 'show_less' : 'show_more'}`;
    const showDateLine = !!(started_at || ended_at);
    const descriptionOpen = moreInfoOpen || !hasMoreInfo;

    const toggleMoreInfo = () => {
        setMoreInfoOpen(!moreInfoOpen);
    };

    return (
        <div className="notable-clients-client-popover">
            <div className="image-line m-b-16">
                <Avatar username={sellerName} src={profilePhoto} size={48}/>
                <ClientLogo logoPath={logoPath} name={name} size={ClientLogo.SIZES.BIG}/>
            </div>
            { interaction_description && (
                <>
                    <b className="about">
                        <I18n k="gig_page_perseus.notableClients.about_my_work"/>
                        &nbsp;
                        { name }
                    </b>
                    { showDateLine && (
                        <p className="dates">
                            <DateDisplay date={started_at}/>
                            { started_at && ended_at && '-'}
                            <DateDisplay date={ended_at}/>
                        </p>
                    )}
                    <p className="interaction-description m-t-8">
                        { interaction_description }
                    </p>
                </>
            )}
            { showEnrichBox && (
                <div className="enriched-box m-t-24">
                    { description && (
                        <div className="description">
                            { descriptionOpen ? description : previewDescription }
                            &nbsp;
                            { hasMoreInfo && (
                                <button onClick={toggleMoreInfo}>
                                    <I18n k={hasMoreKey}/>
                                </button>
                            )}
                        </div>
                    )}
                    { industry && (
                        <div className="industry">
                            <I18n k="gig_page_perseus.notableClients.industry"/>:&nbsp;{ industry }
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

DetailsPopover.propTypes = {
    profilePhoto: string,
    sellerName: string,
    client: object
};

export default DetailsPopover;
